import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import React, { useCallback } from "react";

interface IMosaicLayoutProps {
  focusedButton: string;
  setFocusedButton: React.Dispatch<React.SetStateAction<string>>;
}

const MosaicLayout = (props: IMosaicLayoutProps): JSX.Element => {
  const { focusedButton, setFocusedButton } = props;

  const handleChange = useCallback(
    (event: React.MouseEvent<HTMLElement>, newVal: string) => {
      if (newVal) setFocusedButton(newVal);
    },
    [setFocusedButton]
  );

  return (
    <ToggleButtonGroup value={focusedButton} exclusive onChange={handleChange}>
      <ToggleButton value="current">Keep Existing Layout</ToggleButton>
      <ToggleButton value="reset">Reset Layout</ToggleButton>
    </ToggleButtonGroup>
  );
};

export { MosaicLayout };
